import React, {useRef, useEffect, useState} from "react";
import { Popconfirm,message,Col, Row, ConfigProvider, Modal, Input, DatePicker, Checkbox} from 'antd';
import { sendHttpPostRequest } from "../../../api/http-request";
import "../course.module.css";
import zhCN from 'antd/lib/locale/zh_CN'
import {checkUserLogin} from "../../common/user-center/user-info";
import courseMainStyles from "../course-main.module.less";
import courseMainTestListStyles from './course-main-teacher-test-list.module.less';
import zuoyeEmpty from "../../../static/image/empty/queshengye-zuoye.png";
import Cookies from "js-cookie";
import Draggable from 'react-draggable'
import 'moment/locale/zh-cn';
import moment from 'moment';
import { getRangeDate } from "../../common/utils/util";


import Icon from '@ant-design/icons'
import  {ReactComponent as myplusSvg }   from '../../../static/image/course/myplus.svg'
const myplusIcon = (props:any) => (<Icon component={myplusSvg} {...props} />)

import  {ReactComponent as calendargreenSvg }   from '../../../static/image/course/calendar-check.svg'
const calendargreenIcon = (props:any) => (<Icon component={calendargreenSvg} {...props} />)
import  {ReactComponent as calendarredSvg }   from '../../../static/image/course/calendar-close-line.svg'
const calendarredIcon = (props:any) => (<Icon component={calendarredSvg} {...props} />)


import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
import { ReactComponent as publishSvg }   from '../../../static/image/course/publish.svg'
import { ReactComponent as deleteSvg }   from '../../../static/image/module/delete.svg'

const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
const publishIcon = (props:any) => (<Icon component={publishSvg} {...props} />)
const deleteIcon = (props:any) => (<Icon component={deleteSvg} {...props} />)


const { TextArea } = Input

export interface Props {
    course_id : any,
    college_id: any,
    menu_id : any,
    assistant: any,
}



const dateFormat = 'YYYY-MM-DD HH:mm';

/** 教师课程作业列表页面 */
export const CourseMainTeacherTestList: React.FC<Props> = (props) => {
    const {course_id,college_id,menu_id,assistant} = props;
    const [homeworkList, setHomeworkList] = useState([] as any[]);

    const [homeworkName, setHomeworkName] = useState('');  // 作业名称
    const [homeworkDescription, setHomeworkDescription] = useState('');  // 作业说明
    const [submitTime, setSubmitTime] = useState(moment().utc().zone(-8).add(2, 'hours').format(dateFormat).toString() as any);  // 作业提交时间
    const [deadline, setDeadline] = useState(moment().utc().zone(-8).add(4, 'hours').format(dateFormat).toString() as any);  // 作业最晚时间
    const [allowDelay, setAllowDelay] = useState(false);  // 接受作业延迟提交

    /** 以下是创建作业弹出框显示用到的变量和函数 */
    const [isModalVisible, setIsModalVisible] = useState(false)
    const draggleRef = useRef<HTMLDivElement | null>(null)

    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [disabled, setDisabled] = useState(true)

    const statusStyles= (testStatus: string) => {
      if (testStatus == '进行中') {
        return {color:'#0ea5e9', background:'#0ea5e91a'}
      } else if (testStatus == '未发布') {
        return {color:'#6b7280', background:'#6b72801a'}
      }  else if (testStatus == '已完成') {
        return {color:'#10b981', background:'#10b9811a'}
      }

    }

    const onStart = (event: any, uiData: any) => {
        const { clientWidth, clientHeight } = window?.document?.documentElement
        const targetRect = draggleRef?.current?.getBoundingClientRect()
        if (targetRect) {
        setBounds({
            left: -targetRect?.left + uiData?.x,
            right: clientWidth - (targetRect?.right - uiData?.x),
            top: -targetRect?.top + uiData?.y,
            bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        })
        }
    }

    const disabledSubmitDate = (current:any) => {
        return current && current < moment().startOf('day');
      }
  
      const disabledEndDate = (current:any) => {
        return current && current < moment(submitTime).startOf('day');
      }
  
      // 提交时间改变
      const onSubmitTimeChange = (value: any, dateString: any) => {
          setSubmitTime(dateString);
          setDeadline(moment(dateString).utc().zone(-8).add(2, 'hours').format(dateFormat).toString() as any);
      }
  
      // 延迟时间改变
      const onDeadlineChange = (value: any, dateString: any) => {
          setDeadline(dateString);
      }
  
      // 接受延迟提交
      const onDelayChecked = () => {
          setAllowDelay(!allowDelay);
      }
  
      // 获取当前时间
      const currentTime = moment().valueOf();
      const range = (start, end) => {
        const result:any = [];
        for (let i = start; i < end; i++) {
          result.push(i);
        }
        return result;
      };
      
      // 截止时间与当前时间牵制
      const disabledSubmitTime:any = (dateTime) => { 
        // 判断所选日期与当前日期是否相等  
        if (moment(dateTime).isSame(moment(currentTime), "day")) {
            return {
              disabledHours: () => range(0, moment(currentTime).hour()),
              disabledMinutes: () =>
                moment(dateTime).isSame(moment(currentTime), "hour")
                  ? range(0, moment(currentTime).minute())
                  : []
            };
          }else return [];
      };
  
      // 最晚时间与截止时间牵制
      const disabledEndTime:any = (dateTime) => {
        if (moment(dateTime).isSame(moment(submitTime), "day")) {
          return {
            disabledHours: () => range(0, moment(submitTime).hour()),
            disabledMinutes: () =>
              moment(dateTime).isSame(moment(submitTime), "hour")
                ? range(0, moment(submitTime).minute())
                : []
          };
        }else return [];
      }

    // 点击确认创建作业
    const createHomeWork = () => {
        message.destroy()
        sendHttpPostRequest(
            'homework/api/user_create_homework/',
            {
                sessionid: Cookies.get('sessionid'),
                course_id: course_id,
                college_id: college_id,  
                name: homeworkName,
                description: homeworkDescription,
                submit_time: submitTime,
                deadline: deadline,
                allow_delay: allowDelay,
            },
            (response:any) => {
              message.destroy();
              if (response.code == -100) {
                // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
              } else if (response.code == -501) {
                // 没权限
                message.error("权限不足")
              } else if (response.is_ok == true) {
                // 创建成功 直接 转入 新建作业编辑页面  
                // 刷新作业列表
                // 关闭弹出框
                queryHomeworkList()
                setIsModalVisible(false)
                setHomeworkName('')
                setHomeworkDescription('')
                const new_homework_id = response.homework_id
                window.open('/course-new-test?test_id='+new_homework_id+'&course_id='+course_id+'&menu_id=' + menu_id )
              } else {
                message.error(response.message);
              }
            }
        )
    }


    /** 确认布置作业 */
    const handleOk = () => {
        //确认创建作业
        createHomeWork()
    }
    // 取消布置作业
    const handleCancel = () => {
        //取消创建作业
        setHomeworkName('')
        setHomeworkDescription('')
        setIsModalVisible(false)
    }
    
    // 点击删除按钮
    const onDeleteBtnClick = (testTitle:string, testId:number) => {
        deleteHomework(testId);
    }

    /**
     * 查询作业回调
     * @param response
     */
    const queryHomeworkListCallback = (response:any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("权限不足");
        } else if (response.is_ok == true) {
            setHomeworkList(response.query_list);
        }
    }

    // 查询作业列表
    const queryHomeworkList = () => {
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            sendHttpPostRequest(
                'homework/api/user_query_homework_list/',
                {
                    sessionid: Cookies.get("sessionid"),
                    course_id: course_id,
                    college_id: college_id
                },
                queryHomeworkListCallback
            )
        }
    }

    /**
     * 删除作业回调
     * @param response
     */
    const deleteHomeworkCallback = (response:any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("权限不足");
        } else if (response.is_ok == true) {
            //message.success("删除作业成功~");
            queryHomeworkList();
        } else {
            message.error("删除作业失败~");
        }
    }

    /** 删除作业 */
    const deleteHomework = (homeworkId:any) => {
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            sendHttpPostRequest(
                'homework/api/user_delete_homework/',
                {
                    sessionid: Cookies.get("sessionid"),
                    sid: Cookies.get("sessionid"),
                    homework_id: homeworkId,
                },
                deleteHomeworkCallback
            )
        }
    }


    const onPreviewTestClick = (test_id:string, test_status: any, event:any) => {
      if (!checkUserLogin()) {
          document.getElementById("show-login-modal")!.click();
      } else {
          if (["未发布"].includes(test_status)){
            window.open('/course-new-test?test_id=' + test_id  + '&course_id=' + course_id + '&menu_id=' + menu_id);
          }else{
              window.open('/course-teacher-test-preview?test_id=' + test_id  + '&course_id=' + course_id + '&menu_id=' + menu_id);
          }
        }
    }


    const onPublishTestClick = (test_id:string, test_status: any, event:any) => {
      if (!checkUserLogin()) {
          document.getElementById("show-login-modal")!.click();
      } else {
        const params = {
            sessionid: Cookies.get("sessionid"),
            homework_id: test_id,
            status: 2,//发布状态
        };
        sendHttpPostRequest(
            'homework/api/user_update_homework/',
            params,
            (response:any) => {
                message.destroy();
                if (response.code == -100) {
                    // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
                } else if (response.code == -501) {
                    // 没权限
                    message.error("权限不足");
                } else if (response.is_ok == true) {
                    queryHomeworkList()
                    //message.success("作业发布成功~")
                    
                }else {
                    message.error(response.message);
                }
            }
        )
        }
    }

  

    useEffect(()=> {
        queryHomeworkList();
    },[])



    return (     
        <div >
          <Row wrap={false} align={"middle"} style={{margin: '0 0 24px'}}>
            <Col span={12} style={{textAlign:'left'}}>
                <div className={courseMainStyles.courseTabContentTitle}>作业管理</div>
            </Col>

            <Col span={12} style={{textAlign:'right'}}>
              <div >
              
                 <span
                      style={{fontSize:14, padding:'4px 12px'}}
                      className={courseMainStyles.BtnDark}
                     onClick={()=>{setIsModalVisible(true)}}
                  >
                    <Icon component={myplusIcon}/> 创建作业
                  </span> 
                
    
              </div>
            </Col>
          </Row>

          <Row align={"middle"} gutter={[24,24]}>
            {
              homeworkList?.map((test, testIndex)=>(
                  <Col span={24} key={testIndex}>
                    <div className={courseMainTestListStyles.testCard}>
                        <Row wrap={false} align={"top"}>
                            <Col flex={"auto"} style={{textAlign:'left'}}>
                              <div>
                                  <div className={courseMainTestListStyles.testCardTitle} > {test?.name} <span className={courseMainTestListStyles.statusSpan} style={statusStyles(test?.status)}> {test?.status} </span></div>
                                  <div className={courseMainTestListStyles.testCardDesp} > {test?.description}</div>
                                  <div className={courseMainTestListStyles.testCardTimeDiv}> 
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={calendargreenIcon}/> 发布时间:  {test?.create_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={calendarredIcon}/> 截止时间:  {test?.submit_time} </span>
                                    { test?.allow_delay !== 0 && <span className={courseMainTestListStyles.testCardTimeItem}  > <Icon component={calendarredIcon}/>  延迟提交:  {test?.deadline}</span>}
                                  </div>
                              </div>
                            </Col>
                            <Col flex={"300px"} style={{textAlign:'right'}}>
                              <div>
                                { test?.status == "未发布" && <span style={{fontSize:14, padding:'6px 12px'}} className={courseMainStyles.BtnDark} onClick={onPublishTestClick.bind(this,test?.id,test?.status)}  > <Icon component={publishIcon}/> 发布 </span> }
                                <span  style={{fontSize:14, padding:'6px 12px', marginLeft:12}} className={courseMainStyles.BtnLight} onClick={onPreviewTestClick.bind(this,test?.id,test?.status)}  > <Icon component={eyeIcon}/> 查看 </span>
                                
                                <Popconfirm placement="top" title={'确认删除作业"' + test?.name + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, test?.name,test?.id)} okText="确认" cancelText="取消">
                                  <span style={{fontSize:14, padding:'6px 12px', marginLeft:12, display:assistant?"none":"inline-block"}} className={courseMainStyles.BtnDelete} > <Icon component={deleteIcon}/> 删除 </span>
                                </Popconfirm>

                              </div>
                            </Col>                            
                        </Row>
                    </div>
                  </Col>
              ))
            }
          </Row>


            {homeworkList.length==0 &&
                <div style={{textAlign:'center',paddingTop:20}}>
                    <img src={zuoyeEmpty} width={120} height={120}/>
                    <div style={{color:'#999',marginTop:10}}>{assistant ? '老师还没有布置作业哟': '您还没有布置作业哟'}~</div>
                </div>
            }



            <Modal
                  title={
                    <div
                      style={{
                        width: '100%',
                        cursor: 'move',
                      }}
                      onMouseOver={() => {
                        if (disabled) {
                          setDisabled(false)
                        }
                      }}
                      onMouseOut={() => {
                        setDisabled(true)
                      }}
                      onFocus={() => {}}
                      onBlur={() => {}}
                      // end
                    >
                      布置作业
                    </div>
                  }
                  closable={true}
                  open={isModalVisible}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  bodyStyle={{ minHeight: '300px' }}
                  destroyOnClose={true}
                  width={600}
                  modalRender={(modal) => (
                    <div className={courseMainTestListStyles.createDiv}>
                      <ConfigProvider locale={zhCN}>
                      <Draggable
                        disabled={disabled}
                        bounds={bounds}
                        onStart={(event, uiData) => onStart(event, uiData)}
                      >
                        <div ref={draggleRef}>{modal}</div>
                      </Draggable>
                      </ConfigProvider>
                    </div>
                  )}
                >
                    <div>
                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:30}}>
                        <Col span={4} style={{color:"#00000073", textAlign:'left'}}>作业标题<span style={{color:'#FF4B50', marginLeft:5}}>*</span></Col>

                        <Col style={{textAlign:'left'}} span={20}> <Input style={{borderRadius:3}} value={homeworkName} onChange={(e:any)=>{setHomeworkName(e.target.value)}} /> </Col>
                    </Row>

                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:30}}>
                <Col span={4} style={{color:"#00000073", textAlign:'left'}} >截止时间 <span style={{color:'#FF4B50', marginLeft:5}}>*</span></Col>
                               
                <Col style={{textAlign:'left'}}  >
                  <DatePicker  
                  value={submitTime ? moment(submitTime, dateFormat) : moment(getRangeDate(1), dateFormat)}
                  allowClear={false}
                  disabledDate = {disabledSubmitDate}
                  format={dateFormat}
                  showTime
                  onChange={onSubmitTimeChange}
                  disabledTime={disabledSubmitTime}
                  />
                  </Col>
                  <Col style={{textAlign:'left',fontSize:12,paddingRight:0,color:'#666'}} >
                     {/* <Switch  defaultChecked  />   */}
                     <Checkbox checked={allowDelay ? true : false} onChange={onDelayChecked} style={{margin:'0 8px 0 10px'}}/>接受作业延迟提交
                  </Col>
              </Row>
                <Row gutter={[8,8]} justify='start' hidden={!allowDelay} align='middle' style={{marginBottom:30}}>
                  <Col span={4} style={{color:"#00000073", textAlign:'left'}} >最晚时间</Col>
                  <Col style={{textAlign:'left'}} >
                      <DatePicker
                          value={deadline ? moment(deadline, dateFormat) : moment(getRangeDate(1), dateFormat)}
                          allowClear={false}
                          disabledDate = {disabledEndDate}
                          format={dateFormat}
                          showTime
                          onChange={onDeadlineChange}
                          disabledTime={disabledEndTime}
                      />
                  </Col>
                </Row>

                        <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:30}}>
                        <Col span={4} style={{color:"#00000073", textAlign:'left'}}>作业说明 <span style={{color:'#FF4B50', marginLeft:5}}>*</span> </Col>
                        <Col span={20}>
                            <TextArea
                                style={{borderRadius:6}}
                                rows={6}
                                showCount={true}
                                maxLength={1000}
                                value={homeworkDescription}
                                onChange={(e: any)=>{setHomeworkDescription(e.target.value)}}
                            ></TextArea>
                        </Col>
                    </Row>
                    </div>
                </Modal>

        </div>
    )

}

export default CourseMainTeacherTestList

